module.exports = __webpack_public_path__ + "src/assets/img/page9/dd02fd117732e8f97360faf90ed1405e.jpg";